import * as ApiNames from 'self-service-api/constants/ApiNames';
import Products from 'merchandise-lib/constants/Product';

// This is used to submit product_upgrade_interest to 53
// If a new value is added here, let #marketing-tech know and make a request in #53-data-questions using the slack shortcut /53_data_help
export const productUpgradeInterest = {
  //temporary duplicates for apiNames
  [ApiNames.SALES_HUB_FREE]: 'Sales-Free',
  [Products.SALES_HUB_STARTER]: 'Sales-Starter',
  [Products.SALES_HUB_PROFESSIONAL]: 'Sales-Professional',
  [Products.SALES_HUB_ENTERPRISE]: 'Sales-Enterprise',
  [Products.MARKETING_HUB_FREE]: 'Marketing-Free',
  [Products.MARKETING_HUB_STARTER]: 'Marketing-Starter',
  [Products.MARKETING_HUB_BASIC]: 'Marketing-Basic',
  [Products.MARKETING_HUB_PROFESSIONAL]: 'Marketing-Pro',
  [Products.SERVICE_HUB_FREE]: 'Service-Free',
  [Products.SERVICE_HUB_STARTER]: 'Service-Starter',
  [Products.SERVICE_HUB_PROFESSIONAL]: 'Service-Professional',
  [Products.SERVICE_HUB_ENTERPRISE]: 'Service-Enterprise',
  [Products.CMS_HUB_STARTER]: 'CMS-Starter',
  [Products.CMS_HUB_PROFESSIONAL]: 'CMS-Professional',
  [Products.CMS_HUB_ENTERPRISE]: 'CMS-Enterprise',
  [Products.OPERATIONS_HUB_STARTER]: 'Operations-Starter',
  [Products.OPERATIONS_HUB_PROFESSIONAL]: 'Operations-Professional',
  [Products.OPERATIONS_HUB_ENTERPRISE]: 'Operations-Enterprise',
  [Products.CRM_SUITE_STARTER_BUNDLE]: 'Starter Suite',
  [Products.CRM_SUITE_PROFESSIONAL_BUNDLE]: 'Professional Suite',
  [Products.CRM_SUITE_ENTERPRISE_BUNDLE]: 'Enterprise Suite',
  [Products.TECH_SERVICE_DEDICATED_IP_FOR_EMAIL]: 'Marketing-Dedicated IP',
  [Products.TRANSACTIONAL_EMAIL]: 'Marketing-Transactional Email',
  [Products.BRAND_DOMAIN]: 'Brand-Domain',
  [Products.STARTER_KIT]: 'Starter Kit',
  [Products.SALES_HUB_PROFESSIONAL_ONBOARDING]: 'Sales Professional Onboarding',
  [Products.SERVICE_HUB_PROFESSIONAL_ONBOARDING]: 'Service Professional Onboarding',
  [Products.MARKETING_HUB_ENTERPRISE]: 'Enterprise',
  [Products.WEB_HOSTING_CUSTOM_SSL_PACK]: 'Custom-SSL',
  [Products.ADS_LIMIT_INCREASE]: 'Marketing-Ads',
  [Products.REPORTING_LIMIT_INCREASE]: 'reporting',
  [Products.DOMAINS_LIMIT_INCREASE]: 'Domains-Limit-Increase',
  [Products.SANDBOX_LIMIT_INCREASE]: 'Sandbox-Limit-Increase',
  [Products.ESIGNATURE_LIMIT_INCREASE]: 'Esignature-Limit-Increase',
  [Products.WORKFLOWS_LIMIT_INCREASE]: 'Workflows-Addon',
  [Products.CALLING_LIMIT_INCREASE]: 'Calling-Limit-Increase',
  [Products.PHONE_LIMIT_INCREASE]: 'Phone-Limit-Increase',
  [Products.WHATSAPP_LIMIT_INCREASE]: 'Whatsapp-Limit-Increase',
  [Products.VIDEO_LIMIT_INCREASE]: 'Video-Limit-Increase',
  [Products.NON_MARKETING_CONTACTS_LIMIT_INCREASE]: 'non-marketing-contacts-limit-increase',
  ['BUNDLE']: 'Bundle',
  // what the pricing page sends when multiple products are selected

  [Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL]: 'marketing-plus-professional-bundle',
  [Products.MARKETING_PLUS_SUITE_BUNDLE_ENTERPRISE]: 'marketing-plus-enterprise-bundle',
  [Products.CUSTOM_PROPERTIES_LIMIT_INCREASE]: 'custom-properties-limit-increase',
  [Products.CRM_OBJECT_LIMIT_INCREASE]: 'crm-object-limit-increase',
  [Products.CALCULATED_PROPERTIES_LIMIT_INCREASE]: 'calculated-properties-limit-increase',
  [Products.USERS_LIMIT_INCREASE]: 'users-limit-increase',
  [Products.CUSTOM_OBJECTS_LIMIT_INCREASE]: 'custom-objects-limit-increase',
  [Products.MARKETING_SMS]: 'marketing-sms',
  [Products.MARKETING_SMS_LIMIT_INCREASE]: 'marketing-sms-limit-increase',
  [Products.TEAMS_LIMIT_INCREASE]: 'Teams-Limit-Increase',
  [Products.CORE_SEATS_STARTER]: 'core-seats-starter',
  [Products.CORE_SEATS_PROFESSIONAL]: 'core-seats-professional',
  [Products.CORE_SEATS_ENTERPRISE]: 'core-seats-enterprise',
  [Products.HUBSPOT_FOR_STARTUPS_SETUP]: 'hubspot-for-startups-setup'
};